import ReactDOM from "react-dom";
import React, { Fragment, useState, useEffect, useRef } from "react";
import Helmet from "react-helmet";
import { withRouter } from "react-router";
import { Link, NavLink } from "react-router-dom";
import moment from "moment";

import { icons } from "constants/icons";
import { history } from "utils";
import { notificationActions, userActions } from "actions";
import { connect } from "react-redux";

import { Logo, Footer, UserIcon, NotificationsList } from "components";
import { Badge, Icon, Button, Menu, Dropdown, Popover } from "antd";
import { Can } from "constants/abilityContext";

import notifSound from "assets/media/notif-sound.mp3";
import { sessionService } from "services";

const notifSoundPlayer = new Audio(notifSound);

export const notificationDispatchToProps = (dispatch) => ({
  updateNotifiedAt: () =>
    dispatch(
      userActions.updateCurrentUser({
        notified_at: moment().toISOString(),
      }),
    ),
});

const NotificationsButton = connect(
  null,
  notificationDispatchToProps,
)((props) => {
  const { type, placement, notifications, notifier, updateNotifiedAt } = props;
  const popoverRef = useRef();
  const [initFetchDone, setInitFetchDone] = useState(false);
  const [initSubDone, setInitSubDone] = useState(false);
  const [historyUnseenCount, setHistoryUnseenCount] = useState(0);

  useEffect(() => {
    setHistoryUnseenCount(notifications.unseen_count || 0);
  }, [notifications.unseen_count]);
  useEffect(() => {
    !initFetchDone && fetch(1);
  }, [initFetchDone]);
  useEffect(() => {
    !initSubDone && subscribe();
  }, [initSubDone]);
  const realTimeNotifs = notifications.data.filter((n) => !!n._isRealTime);
  useEffect(() => {
    realTimeNotifs.length && notifSoundPlayer.play();
  }, [realTimeNotifs.length]);

  const subscribe = () => {
    notifier.subscribe();
    setInitSubDone(true);
  };
  const fetch = (page_number) => {
    if (!initFetchDone) setInitFetchDone(true);
    notifier.fetch(page_number);
  };
  const handleClick = () => {
    setHistoryUnseenCount(0);
    updateNotifiedAt();
  };
  const onItemLinkClick = () => {
    // façon un peu cavalière de fermer le popover quand on clique sur le lien dans une notif
    popoverRef.current && popoverRef.current.click();
  };
  const onNotificationSeen = () => {
    updateNotifiedAt();
  };
  const Notifications = (
    <NotificationsList
      loading={!initFetchDone}
      notifications={notifications}
      fetch={fetch}
      onItemLinkClick={onItemLinkClick}
      onItemHover={onNotificationSeen}
    />
  );

  const isNew = (n) => {
    return !!n._isRealTime && n.date > notifications?.userLastNotifiedDate;
  };
  let newCount = 0;
  if (notifications) {
    let data = notifications.data;
    newCount = data.reduce((acc, n) => (isNew(n) ? acc + 1 : acc), 0);
  }

  return (
    <Popover
      onClick={handleClick}
      trigger="click"
      placement={placement}
      destroyTooltipOnHide={false}
      content={Notifications}
    >
      <span ref={popoverRef} className="notification-button-container">
        <Badge count={historyUnseenCount + newCount} overflowCount={99}>
          <Button type="circle" icon="notification" />
        </Badge>
      </span>
    </Popover>
  );
});

class SideNav extends React.Component {
  constructor(props) {
    super(props);

    this.state = { opened: false };

    const { history } = this.props;
    this.unlisten = history.listen((location, action) => {
      if (this.state.opened) this.setState({ opened: false });
    });

    this.handleUserClick = this.handleUserClick.bind(this);
  }

  componentWillUnmount() {
    this.unlisten();
  }
  componentDidUpdate() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  handleUserClick(e) {
    switch (e.key) {
      case "show-user":
        history.push(`/users/${this.props.user.id}`);
        break;
      case "edit-user":
        history.push(`/users/${this.props.user.id}/edit`);
        break;
      case "logout":
        this.props.logoutUser();
        break;
      case "toggle-menu":
        this.setState({ opened: !this.state.opened });
        break;
      case "go-to-consultation":
        this.props.setViewMode("consultation");
        history.push("/");
        break;
      case "go-to-admin":
        this.props.setViewMode("admin");
        history.push("/");
        break;
    }
  }

  render() {
    const { consultation, notifications, notifier } = this.props;

    const burger = (
      <a
        className={"burger" + (this.state.opened ? " close" : "")}
        onClick={() => this.handleUserClick({ key: "toggle-menu" })}
      >
        <span></span>
        <span></span>
        <span></span>
      </a>
    );

    const userLinks = (
      <Menu onClick={this.handleUserClick}>
        <Menu.Item key="go-to-consultation">
          <Icon type="eye" />
          Passer en mode consultation
        </Menu.Item>
        <Menu.Item key="show-user">
          <Icon type="user" />
          Voir le profil
        </Menu.Item>
        <Menu.Item key="edit-user">
          <Icon type="edit" />
          Éditer le profil
        </Menu.Item>
        <Menu.Item key="logout" className="red" onClick={() => sessionService.destroy()}>
          <Icon type="logout" />
          Déconnexion
        </Menu.Item>
      </Menu>
    );

    if (consultation) {
      return (
        <Fragment>
          <nav className="top-nav">
            <div className="header-logo-wrap">
              {burger}
              <div className="right-wrap">
                <Button href="/#/logs" className="log-btn">
                  <Icon type={icons.logs} />
                  Journal de chantier
                </Button>
                <NotificationsButton
                  placement="bottom"
                  notifications={notifications}
                  notifier={notifier}
                />
                <Logo />
              </div>
            </div>

            <div className={"drawer " + (this.state.opened ? "opened" : "closed")}>
              <div className="drawer-wrap">
                <div className="header-logo-wrap">
                  {burger}
                  <Logo />
                </div>

                <ul>
                  <li>
                    <NavLink to="/" exact>
                      <Icon type={icons.home} />
                      <span>Accueil</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/sse">
                      <Icon type={icons.sse} />
                      <span>Inter. SSE</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/logs">
                      <Icon type={icons.logs} />
                      <span>Journal de chantier</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/projects">
                      <Icon type={icons.project} />
                      <span>Projets</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/documents">
                      <Icon type={icons.document} />
                      <span>Médias</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/chat">
                      <Icon type={icons.messages} />
                      <span>Messages</span>
                    </NavLink>
                  </li>
                </ul>

                <div className="buttons">
                  <Can do="read_admin" on="General">
                    <Button
                      type="round"
                      icon="dashboard"
                      onClick={() => this.handleUserClick({ key: "go-to-admin" })}
                    >
                      Mode administrateur
                    </Button>
                  </Can>
                  <Button
                    type="round"
                    icon="logout"
                    onClick={() => this.handleUserClick({ key: "logout" })}
                    className="red"
                  >
                    Déconnexion
                  </Button>
                </div>

                <Footer />
              </div>
            </div>
          </nav>
        </Fragment>
      );
    }
    return (
      <Fragment>
        <nav className="side-nav">
          <div className="header-logo-wrap">
            <Logo />
            <div className="buttons">
              <NotificationsButton
                type="inline"
                placement="bottom"
                notifications={notifications}
                notifier={notifier}
              />
              <Button type="circle" icon={icons.logs} href="/#/logs" />
              <Button
                type="circle"
                icon="eye"
                onClick={() => this.handleUserClick({ key: "go-to-consultation" })}
              />
              <Button
                type="circle"
                icon="user"
                onClick={() => this.handleUserClick({ key: "show-user" })}
              />
              <Button
                type="circle"
                icon="logout"
                onClick={() => {
                  sessionService.destroy();
                  this.handleUserClick({ key: "logout" });
                }}
                className="red"
              />
              <Button
                type="circle"
                icon="menu"
                onClick={() => this.handleUserClick({ key: "toggle-menu" })}
                className="grey"
              />
            </div>
          </div>

          <ul className={this.state.opened ? "opened" : "closed"}>
            <li>
              <NotificationsButton
                placement="rightTop"
                notifications={notifications}
                notifier={notifier}
              />
            </li>
            <li>
              <NavLink to="/" exact>
                <Icon type={icons.home} />
                <span>Accueil</span>
              </NavLink>
            </li>
            {this.props.user.type_id == 1 && (
              <li>
                <NavLink to="/tv" exact>
                  <Icon type="desktop" />
                  <span>Accueil TV</span>
                </NavLink>
              </li>
            )}
            {this.props.user.type_id == 1 && (
              <li>
                <NavLink to="/tv2" exact>
                  <Icon type="desktop" />
                  <span>Accueil TV v2</span>
                </NavLink>
              </li>
            )}
            {this.props.user.type_id == 1 && (
              <li>
                <NavLink to="/tv-soumissions" exact>
                  <Icon type="desktop" />
                  <span>Soumissions TV</span>
                </NavLink>
              </li>
            )}
            <li>
              <NavLink to="/sse">
                <Icon type={icons.sse} />
                <span>Inter. SSE</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/projects">
                <Icon type={icons.project} />
                <span>Projets</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/logs">
                <Icon type={icons.logs} />
                <span>Journal de chantier</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/dashboardsoumissions">
                <Icon type={icons.dashestimation} />
                <span>Dashboard soumissions</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/data-soumissions">
                <Icon type={icons.dashboard} />
                <span>Data soumission</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/submissions">
                <Icon type={icons.submission} />
                <span>Soumissions</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/dashboard" exact>
                <Icon type={icons.dashboard} />
                <span>Tableau de bord</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/documents">
                <Icon type={icons.document} />
                <span>Médias</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/chat">
                <Icon type={icons.messages} />
                <span>Messages</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/clients">
                <Icon type={icons.client} />
                <span>Clients</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/tailgates">
                <Icon type={icons.tailgate} />
                <span>Tailgates</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/incidents">
                <Icon type={icons.incident} />
                <span>Incidents</span>
              </NavLink>
            </li>

            <li>
              <NavLink to="/notes">
                <Icon type={icons.note} />
                <span>Non-conformités</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/users">
                <Icon type={icons.user} />
                <span>Utilisateurs</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/options">
                <Icon type={icons.admin} />
                <span>Autres options</span>
              </NavLink>
            </li>
          </ul>

          <div className="user-links">
            <Dropdown overlay={userLinks}>
              <Button>
                <UserIcon size="large" user={this.props.user} />
              </Button>
            </Dropdown>
          </div>
        </nav>
      </Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  const user = state.user.infos || {};
  return {
    user,
    notifications: {
      userLastNotifiedDate: user.notified_at ? moment(user.notified_at) : 0,
      data: state.notifications?.received.map((n) => ({
        ...n,
        date: moment(n.date),
      })),
      ...state.notifications?.receivedMeta,
    },
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    logoutUser: () => dispatch(userActions.logout()),
    setViewMode: (mode) => dispatch(userActions.updateViewMode(mode)),
    notifier: {
      subscribe: () => dispatch(notificationActions.subscribe()),
      send: (message, toUserId) => dispatch(notificationActions.send(message, toUserId)),
      fetch: (page_number) => dispatch(notificationActions.fetch(page_number)),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SideNav));
